/**
 * Get the number of days in any particular month
 * @link https://stackoverflow.com/a/1433119/1293256
 * @param  {integer} m The month (valid: 0-11)
 * @param  {integer} y The year
 * @return {integer}   The number of days in the month
 */
var daysInMonth = function daysInMonth(m, y) {
  switch (m) {
    case 1:
      return y % 4 === 0 && y % 100 || y % 400 === 0 ? 29 : 28;

    case 8:
    case 3:
    case 5:
    case 10:
      return 30;

    default:
      return 31;
  }
};
/**
 * Check if a date is valid
 * @link https://stackoverflow.com/a/1433119/1293256
 * @param  {[type]}  d The day
 * @param  {[type]}  m The month
 * @param  {[type]}  y The year
 * @return {Boolean}   Returns true if valid
 */


var isValidDateValue = function isValidDateValue(d, m, y) {
  return m >= 0 && m < 12 && d > 0 && d <= daysInMonth(m, y);
};

var checkValue = function checkValue(str, max) {
  if (str.charAt(0) !== '0' || str === '00') {
    var num = parseInt(str);
    if (isNaN(num) || num <= 0 || num > max) num = 1;
    str = num > parseInt(max.toString().charAt(0)) && num.toString().length === 1 ? "0" + num : num.toString();
  }

  return str;
};

export var autoCompleteDateString = function autoCompleteDateString(value) {
  var input = value;
  if (/\D\-$/.test(input)) input = input.substr(0, input.length - 3);
  var values = input.split('-').map(function (v) {
    return v.replace(/\D/g, '');
  });
  if (values[0]) values[0] = checkValue(values[0], 31);
  if (values[1]) values[1] = checkValue(values[1], 12);
  var output = values.map(function (v, i) {
    return v.length === 2 && i < 2 ? v + "-" : v;
  });
  return output.join('').substr(0, 10);
};
export var sanitizeDateString = function sanitizeDateString(dateString) {
  var input = dateString;
  var values = input.split('-').map(function (v) {
    return v.replace(/\D/g, '');
  });
  var output = '';

  if (values.length === 3) {
    var year = values[2].length !== 4 ? parseInt(values[2]) + 2000 : parseInt(values[2]);
    var month = parseInt(values[1]) - 1;
    var day = parseInt(values[0]);
    var d = new Date(year, month, day);

    if (!isNaN(d.getDate())) {
      var dates = [d.getDate(), d.getMonth() + 1, d.getFullYear()];
      output = dates.map(function (segment) {
        var stringSegment = segment.toString();
        return stringSegment.length === 1 ? "0" + stringSegment : stringSegment;
      }).join('-');
      return output;
    }
  }

  return dateString;
};

var isValidDateFormat = function isValidDateFormat(dateString, allowBlank, minYear) {
  // Original JavaScript code by Chirp Internet: www.chirp.com.au
  var maxYear = new Date().getFullYear();
  var errorMsg = ''; // regular expression to match required date format

  var regularExpression = /^(\d{1,2})\-(\d{1,2})\-(\d{4})$/;
  var result = dateString.match(regularExpression);

  if (dateString !== '') {
    if (result) {
      if (parseInt(result[1]) < 1 || parseInt(result[1]) > 31) {
        errorMsg = "invalidDay";
      } else if (parseInt(result[2]) < 1 || parseInt(result[2]) > 12) {
        errorMsg = "invalidMonth";
      } else if (parseInt(result[3]) < minYear || parseInt(result[3]) > maxYear) {
        errorMsg = 'invalidYear';
      }
    } else {
      errorMsg = 'invalidFormat';
    }
  } else if (!allowBlank) {
    errorMsg = 'emptyDate';
  }

  return errorMsg;
};

export var dateFromDateString = function dateFromDateString(dateString) {
  var _a = dateString.split('-'),
      dayInput = _a[0],
      monthInput = _a[1],
      yearInput = _a[2];

  return new Date(parseInt(yearInput), parseInt(monthInput) - 1, parseInt(dayInput));
};
export var validateDate = function validateDate(dateString, hasFilterBehaviour, minYear) {
  if (hasFilterBehaviour === void 0) {
    hasFilterBehaviour = true;
  }

  if (minYear === void 0) {
    minYear = 2000;
  }

  var d = dateFromDateString(dateString);
  var month = d.getMonth();
  var day = d.getDate();
  var year = d.getFullYear();
  var dateFormatMsg = isValidDateFormat(dateString, hasFilterBehaviour, minYear);

  if (dateFormatMsg !== '') {
    return dateFormatMsg;
  }

  if (!isNaN(day) && !isValidDateValue(day, month, year)) {
    return 'invalidValue';
  } else {
    return '';
  }
};
export var formatDate = function formatDate(date) {
  var d = new Date(date);
  var month = "" + (d.getMonth() + 1);
  var day = "" + d.getDate();
  var year = d.getFullYear();
  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  return [day, month, year].join('-');
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Header/filters/daterange/utils.js
// module id = 1036
// module chunks = 0